import { Box } from 'src/components/mui';
import { Loader } from '../loader/Loader';
import { useEffect, useState } from 'react';
import { fileExists } from 'src/utils/fileExists';

type Props = {
  url: string;
};

export function LoadingScreen({ url }: Props) {
  const [isValidUrl, setIsValidUrl] = useState(false);

  useEffect(() => {
    (async () => {
      const isValid = await fileExists(url);
      setIsValidUrl(isValid);
    })();
  }, [url]);

  return (
    <Box id="loading-screen" position="relative" width="100vw" height="100vh" zIndex={9999}>
      <Box
        position="absolute"
        sx={{
          zIndex: 1,
          overflow: 'hidden',
          width: '100%',
          height: '100%',
        }}
      >
        <Box
          sx={{
            background: isValidUrl
              ? `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${url})`
              : '#000',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            width: '100%',
            height: '100%',
            filter: 'blur(5px)',
            transform: 'scale(1.03)',
          }}
        />
      </Box>

      <Loader
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
        }}
        value={undefined}
      />
    </Box>
  );
}
